import client from '@common/utils/rest';

const URL_PREFIX = 'api/spreadSheets';
const FORMATS_URL_PREFIX = `${URL_PREFIX}/formats`;

export const getFolders = (spreadsheetType) => {
    return client({
        path: `${FORMATS_URL_PREFIX}/folders?context=${spreadsheetType}`,
        method: 'GET'
    }).then(
        (response) => {
            return response.entity.formatFolders;
        },
    );
};